import {Component, ViewChild, OnInit, AfterViewInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';
import { CustomSelectComponent, SelectOption } from '../../../../shared/components/custom-select/custom-select';
import { CustomSearchComponent } from '../../../../shared/components/custom-search/custom-search';
import { CustomButtonComponent } from '../../../../shared/components/custom-button/custom-button';
import {
  DeleteConfirmationModalComponent
} from '../../../../shared/components/delete-confirmation-modal/delete-confirmation-modal';

import { Sistema } from '../../../system/model/sistema';
import { PerfilService } from '../../../perfil/services/perfil-config-service';
import { Perfil } from '../../../perfil/models/perfil';
import { SistemaService } from '../../../system/services/system-service';
import { UsuarioService } from '../../services/user-service';
import { UtilCatService } from '../../../../shared/utils/UtilCatService';
import { Usuario, UsuarioExcel } from '../../models/usuario';
import { MatSort } from '@angular/material/sort';
import { MatSortModule } from '@angular/material/sort';
import { TableUtil } from '../../../../shared/utils/tableUtil';
import { Router } from '@angular/router';
import {ModalService} from '../../../../core/services/modal/modal.service';
import {ToastService} from '../../../../core/services/toast/toast-service';
import {LoaderService} from '../../../../core/services/loader/loader-service';
import {CustomTooltipComponent} from '../../../../shared/components/custom-tooltip/custom-tooltip';


@Component({
  selector: 'app-user-config',
  standalone: true,
  templateUrl: './user-config.html',
  styleUrls: ['./user-config.css'],
  imports: [
    CommonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatCardModule,
    FormsModule,
    CustomSelectComponent,
    CustomSearchComponent,
    CustomButtonComponent,
    DeleteConfirmationModalComponent,
    CustomTooltipComponent,
    MatSortModule
  ]
})
export class UserConfigComponent implements OnInit, AfterViewInit  {

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ['username', 'nombre', 'email', 'perfil', 'sistema', 'vigente', 'accion'];

  public sistemas: Sistema[] = [];
  public sistema: Sistema = {} as Sistema;
  public perfiles: Perfil[] = [];
  public perfil: Perfil = {} as Perfil;
  public usuarios: Usuario[] = [];
  public isAdmin: Boolean = UtilCatService.isSuperUser();
  private isExporting = false;

  selectedSystem: string = '';
  selectedPerfil: string = '';
  searchText: string = '';
  dataSource: any;
  showDeleteUserModal = false;
  userToDelete: Usuario | null = null;
  deletingUser: boolean = false;
  titleDeleteModal: string = '';

  sistemasOptions: SelectOption[] = [
    { value: '', label: 'Todos los sistemas' }
  ];

  perfilesOptions: SelectOption[] = [
    { value: '', label: 'Todos los perfiles' },
  ];

  constructor(
    private paginatorIntl: MatPaginatorIntl,
    private sistemaService: SistemaService,
    private perfilService: PerfilService,
    private usuarioService: UsuarioService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private router: Router,
    private modalService: ModalService,
  ) {
    // Configurar paginador en español
    this.paginatorIntl.itemsPerPageLabel = 'Filas por página:';
    this.paginatorIntl.lastPageLabel = 'Última página';
    this.paginatorIntl.firstPageLabel = 'Primera página';
    this.paginatorIntl.nextPageLabel = 'Página siguiente';
    this.paginatorIntl.previousPageLabel = 'Página anterior';

    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }

      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };

    this.paginatorIntl.changes.next();
  }

  ngOnInit() {
    this.loaderService.showLoader();
    this.sistema.id = 0;

    let completedCalls = 0;
    const totalCalls = 3;

    const checkComplete = () => {
      completedCalls++;
      if (completedCalls === totalCalls) {
        this.loaderService.hideLoader();
        this.dataSource.paginator = this.paginator;
      }
    };

    this.getUsuarios(checkComplete, false);
    this.getPerfiles(checkComplete);
    this.getSistemas(checkComplete);
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.dataSource.sortingDataAccessor = (item: any, property: string) => {
        switch (property) {
          case 'nombre':
            return item.nombre + ' ' + item.apellido;
          case 'perfil':
            return item.perfil.length > 0 ? item.perfil[0].nombre : '';
          case 'sistema':
            return item.perfil.length > 0 && item.perfil[0].sistemas.length > 0
              ? item.perfil[0].sistemas[0].nombre
              : '';
          default:
            return item[property];
        }
      };
    }
  }

  navigateToMenu() {
    this.router.navigate(['/menu']);
  }

  onSystemChange(selectedSystem: any) {
    this.selectedSystem = selectedSystem;
    this.sistema.id = selectedSystem;
    this.reapplyCurrentFilters();
  }

  onPerfilChange(selectedPerfil: any) {
    this.selectedPerfil = selectedPerfil;
    this.perfil.id = selectedPerfil;
    this.reapplyCurrentFilters();
  }

  onSearchKeyup(event: KeyboardEvent) {
    this.reapplyCurrentFilters();
  }


  getUsuarios(onComplete?: () => void, closeLoader: boolean = true) {
    this.sistema.id = 0;
    this.perfil.id = 0;
    this.usuarioService.findAll().subscribe({
      next: (res) => {
        this.usuarios = res;
        if (!this.isAdmin) {
          this.usuarios = this.usuarios.filter(x => x.id != 1);
        }
        this.reapplyCurrentFilters();

        if (onComplete) {
          onComplete();
        } else if (closeLoader) {
          this.loaderService.hideLoader();
        }
      },
      error: () => {
        if (onComplete) {
          onComplete();
        } else if (closeLoader) {
          this.loaderService.hideLoader();
        }
      }
    });
  }

  getSistemas(onComplete?: () => void) {
    this.sistemaService.findAll().subscribe({
      next: (res: Sistema[]) => {
        this.sistemas = res;
        this.updateSistemasOptions();
        if (onComplete) onComplete();
      },
      error: (error) => {
        console.error('Error al obtener sistemas:', error);
        this.sistemasOptions = [
          { value: '', label: 'Todos los sistemas' }
        ];
        if (onComplete) onComplete();
      }
    });
  }

  getPerfiles(onComplete?: () => void) {
    this.perfilService.findAll().subscribe({
      next: (res) => {
        this.perfiles = res;
        this.perfilesOptions = [
          { value: '', label: 'Todos los perfiles' },
          ...this.perfiles.map(perfil => ({
            value: perfil.codigo,
            label: perfil.nombre
          }))
        ];
        if (onComplete) onComplete();
      },
      error: (error) => {
        this.perfilesOptions = [
          { value: '', label: 'Todos los perfiles' }
        ];
        if (onComplete) onComplete();
      }
    });
  }

  private updateSistemasOptions() {
    this.sistemasOptions = [
      { value: '', label: 'Todos los sistemas' }
    ];

    this.sistemas.forEach(sistema => {
      this.sistemasOptions.push({
        value: sistema.id?.toString() || '',
        label: sistema.nombre || 'Sistema sin nombre'
      });
    });
  }



  onAddUser() {
    this.modalService.openUsuarioModal({
      usuario: {} as Usuario,
      heading: 'Agregar usuario',
      button: 'Agregar',
      classButton: 'bg-blue-600 hover:bg-blue-700',
      onSave: (usuario: Usuario) => this.onUsuarioSaved(usuario)
    });
  }

  onOpenModalEditUser(usuario: Usuario) {
    this.loaderService.showLoader();
    this.modalService.openUsuarioModal({
      usuario: { ...usuario },
      heading: 'Editar Usuario ' + usuario.username,
      button: 'Guardar Cambios',
      classButton: 'bg-blue-600 hover:bg-blue-700',
      onSave: (usuario: Usuario) => this.onUsuarioSaved(usuario)
    });
    this.loaderService.hideLoader();
  }


  onUsuarioSaved(usuario: Usuario) {
    this.loaderService.showLoader();

    if (usuario.id) {
      this.usuarioService.update(usuario).subscribe({
        next: (res) => {
          this.toastService.showToast('Usuario actualizado exitosamente', 'success');
          this.loaderService.hideLoader();

          const index = this.usuarios.findIndex(u => u.id === res.id);
          if (index !== -1) {
            this.usuarios[index] = res;
          }

          this.dataSource.data = this.usuarios;
          this.getUsuarios();

        },
        error: (error) => {
          this.toastService.showToast('Error al actualizar el usuario', 'error');
          this.loaderService.hideLoader();
        }
      });
    } else {
      this.usuarioService.create(usuario).subscribe({
        next: (res) => {
          this.toastService.showToast('Usuario creado exitosamente', 'success');
          this.loaderService.hideLoader();

          this.usuarios.push(res);

          this.dataSource.data = this.usuarios;
          this.getUsuarios();

        },
        error: (error) => {
          this.toastService.showToast('Error al crear el usuario', 'error');
          this.loaderService.hideLoader();
        }
      });
    }
  }


  onDeleteUser(usuario: Usuario) {
    this.titleDeleteModal = 'Eliminar Usuario'+ ' ' + usuario.username;
    this.userToDelete = usuario;
    this.showDeleteUserModal = true;
  }


  confirmDeleteUser() {
    if (this.userToDelete && !this.deletingUser) {
      this.deletingUser = true;
      const userToDeleteId = this.userToDelete.id;
      this.loaderService.showLoader();

      this.usuarioService.deleted(this.userToDelete).subscribe({
        next: (res) => {
          this.loaderService.hideLoader();
          this.toastService.showToast('Usuario eliminado exitosamente', 'success');
          this.onCloseDeleteModal();
          this.deletingUser = false;

          this.usuarios = this.usuarios.filter(u => u.id !== userToDeleteId);
          this.dataSource.data = this.usuarios;
          this.getUsuarios();
        },
        error: (error) => {
          this.loaderService.hideLoader();
          this.toastService.showToast('Error al eliminar el usuario', 'error');
          this.deletingUser = false;
        }
      });
    }
  }

  onCloseDeleteModal() {
    this.showDeleteUserModal = false;
    this.userToDelete = null;
    this.deletingUser = false;
  }


  onEditVigente(usuario: Usuario) {
    this.loaderService.showLoader();

    const nuevoEstadoVigente = !usuario.vigente;
    usuario.vigente = nuevoEstadoVigente;

    this.usuarioService.update(usuario).subscribe({
      next: (res) => {
        this.toastService.showToast('El usuario ' + usuario.username +
          ' ha sido modificado', 'success');
        this.loaderService.hideLoader();

        const index = this.usuarios.findIndex(u => u.id === usuario.id);
        if (index !== -1) {
          this.usuarios[index].vigente = nuevoEstadoVigente;
        }

        this.dataSource.data = this.usuarios;
        this.getUsuarios();
      },
      error: (error) => {
        this.toastService.showToast('No se logró modificar el usuario ' + usuario.username, 'error');
        this.loaderService.hideLoader();
        usuario.vigente = !nuevoEstadoVigente;
      }
    });
  }

  exportarExcel() {
    if (this.isExporting) {
      return;
    }

    this.isExporting = true;
    this.loaderService.showLoader();

    try {
      let datos: UsuarioExcel[] = [];
      this.usuarios.forEach(element => {
        let data = {} as UsuarioExcel;
        data.Usuario = element.username;
        data.Nombre = element.nombre + ' ' + element.apellido;
        data.Correo = element.email;
        data.Perfiles = '';
        element.perfil.forEach(element => {
          if (data.Perfiles == '') {
            data.Perfiles = data.Perfiles.concat(element.nombre);
          } else {
            data.Perfiles = data.Perfiles.concat('\n\r' + element.nombre);
          }
        });
        data.Vigente = element.vigente == false ? 'No Vigente' : 'Vigente';
        datos.push(data);
      });

      TableUtil.exportToExcelModel(datos);
      this.toastService.showToast('Excel exportado correctamente', 'success');

    } catch (error) {
      this.toastService.showToast('Error al exportar Excel', 'error');
    } finally {
      this.loaderService.hideLoader();

      setTimeout(() => {
        this.isExporting = false;
      }, 2000);
    }
  }

  verificarEliminar(user: Usuario) {
    return UtilCatService.contienePerfilUsuarioNuevo(user);
  }

  getPerfilesLabel(usuario: Usuario) {
    let perfiles = Array.from(new Set(usuario.perfil.map((item: Perfil) => item.nombre)));
    let text = perfiles.map(x => x).join(',').toString();
    return text;
  }

  getCantSis(perfiles: Perfil[]) {
    let sis: Sistema[] = [];
    if (perfiles) {
      perfiles.forEach(perfil => {
        perfil.sistemas.forEach(sistema => {
          if (sis.find((test) => test.id === sistema.id) === undefined) {
            sis.push(sistema);
          }
        });
      });
    }
    return sis.length;
  }

  getSistemasLabel(perfiles: Perfil[]) {
    let sis: Sistema[] = [];
    let text = '';
    if (perfiles) {
      perfiles.forEach(perfil => {
        perfil.sistemas.forEach(sistema => {
          if (sis.find((test) => test.id === sistema.id) === undefined) {
            sis.push(sistema);
          }
        });
      });
    }
    text = sis.map(x => x.nombre).join(',').toString();
    return text;
  }


  private reapplyCurrentFilters() {

    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource<Usuario>(this.usuarios);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }

    this.dataSource.filterPredicate = (data: Usuario, filter: string) => {
      let match = true;
      const lowerCaseFilter = this.searchText.trim().toLowerCase();

     if (this.searchText) {
            const searchMatch =
              data.username?.toLowerCase().includes(lowerCaseFilter) ||
              data.nombre?.toLowerCase().includes(lowerCaseFilter) ||
              data.apellido?.toLowerCase().includes(lowerCaseFilter) ||
              data.email?.toLowerCase().includes(lowerCaseFilter) ||
              data.anexo?.toString().toLowerCase().includes(lowerCaseFilter) ||
              data.perfil?.some(perfil => perfil.nombre?.toLowerCase().includes(lowerCaseFilter)) ||
              data.perfil?.some(perfil =>
                perfil.sistemas?.some(sistema =>
                  sistema.nombre?.toLowerCase().includes(lowerCaseFilter)
                )
              );

            match = match && searchMatch;
          }

      if (this.selectedSystem) {
        const systemMatch = data.perfil?.some(perfil =>
          perfil.sistemas?.some(sistema => sistema.id?.toString() === this.selectedSystem)
        );
        match = match && systemMatch;
      }

      if (this.selectedPerfil) {
        const perfilMatch = data.perfil?.some(perfil => perfil.codigo === this.selectedPerfil);
        match = match && perfilMatch;
      }

      return match;
    };

    this.dataSource.filter = 'trigger';
  }
}
